export default __webpack_public_path__ + "static/media/re7.840a7880.png";